/* eslint-disable max-len */
const AddIcon = ({ colorTheme }: {colorTheme: string}) => {

  const svg = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="${colorTheme}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 8.00061C12.75 7.5864 12.4143 7.25061 12 7.25061C11.5858 7.25061 11.25 7.5864 11.25 8.00061V11.25H8.00061C7.5864 11.25 7.25061 11.5858 7.25061 12C7.25061 12.4142 7.5864 12.75 8.00061 12.75H11.25V15.9995C11.25 16.4137 11.5858 16.7495 12 16.7495C12.4143 16.7495 12.75 16.4137 12.75 15.9995V12.75H15.9995C16.4137 12.75 16.7495 12.4142 16.7495 12C16.7495 11.5858 16.4137 11.25 15.9995 11.25H12.75V8.00061Z" fill="white"/>
    </svg>
  `;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export default AddIcon;
